export function createController() {
  return {
    isActive() {
      return !!this.controller;
    },
    start() {
      this.stop();
      this.controller = new AbortController();
      return this.controller;
    },
    stop() {
      if (this.isActive()) {
        try {
          this.controller.abort();
        } catch (e) {
          void 0;
        }

        delete this.controller;
      }
    },
  };
}
